export default {
    data() {
        return {

        }
    },
    async mounted() {


    },
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    methods: {

        mountTemplate(slot) {
            return "item(" + slot.key + ")"
        },

        mountedPrepareEmbeddable(){
            this.setValue(this.value)
        },

        setValue(v) {
            this.form = v
        },

        async mountedContinuedEmbeddable(){
            this.$emit("mounted", this.userAuth)
        }

    },
    watch: {
        value(v) {
            this.setValue(v)
        },
        form(v) {
            this.$emit("input", v)
        }
    }


}


